import {
  SET_LOADED_USER,
  SET_MEMBERS,
  SET_MEMBER,
  SET_COURSES,
  SET_LOGIN_ERROR,
  ADD_NEW_COURSE,
} from './actions';

const initialState = {
  user: null,
  members: [],
  member: null,
  error: null,
  courses: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADED_USER:
      return { ...state, user: action.payload };
    case SET_MEMBERS:
      return { ...state, members: action.payload };
    case SET_MEMBER:
      return { ...state, member: action.payload };
    case SET_COURSES:
      return { ...state, courses: action.payload };
    case SET_LOGIN_ERROR:
      return { ...state, error: action.payload };
    case ADD_NEW_COURSE:
      const newCourses = [action.payload, ...state.courses];
      return { ...state, courses: newCourses };
    default:
      return { ...state };
  }
};

export default reducer;
